import type {
  LiveViewPresenceTicketResponse,
  LiveViewTicketResponse
} from "shared/utils/live-view/protocol";
import { instance } from "./apiBase";

export const liveViewTicketKey = (applicationId: string) => [
  "LIVE_VIEW_TICKET",
  applicationId
];

/** `applicationIds` sorted and de-duplicated, so the key is stable. */
export const livePresenceTicketKey = (applicationIds: readonly number[]) => [
  "LIVE_VIEW_PRESENCE_TICKET",
  applicationIds.join(",")
];

export const liveViewApi = {
  /**
   * Mints a short-lived ticket for the communication-service `/live-view`
   * socket. Returns `{ enabled: false }` (still HTTP 200) when the partner
   * doesn't have BoomView.
   */
  createTicket: async (
    applicationId: string
  ): Promise<LiveViewTicketResponse> => {
    const response = await instance.post<LiveViewTicketResponse>(
      `/portal/v1/applications/${applicationId}/live_view/ticket`
    );
    return response.data;
  },

  /**
   * A presence-only ticket for list pages: it receives presence for the
   * given applications (at most MAX_PRESENCE_APPLICATIONS) but can't watch.
   * `application_ids` in the response are the ones the user may see.
   */
  createPresenceTicket: async (
    applicationIds: readonly number[]
  ): Promise<LiveViewPresenceTicketResponse> => {
    const response = await instance.post<LiveViewPresenceTicketResponse>(
      "/portal/v1/live_view/presence_ticket",
      { application_ids: applicationIds }
    );
    return response.data;
  }
};
